<script>
  export default {
    name: 'loading-button',

    inheritAttrs: false,

    props: {
      isLoading: {
        type: Boolean,
        required: true
      },
      loadingLabel: {
        type: String,
        default: 'Loading...'
      }
    },

    computed: {
      listeners () {
        return {
          ...this.$listeners
        }
      }
    }
  }
</script>

<template>
  <b-button v-bind="$attrs" v-on="listeners" :disabled="isLoading">
    <span v-if="isLoading">
      <b-spinner small :label="loadingLabel" class="mr-2"/> {{ loadingLabel }}
    </span>
    <slot v-if="!isLoading"></slot>
  </b-button>
</template>

<style src="./LoadingButton.scss" lang="scss" scoped></style>
